angular.module('tgaApp').directive('ngMuted', () => ({
  priority: 99, // it needs to run after the attributes are interpolated
  link(scope, element, attr) {
    attr.$observe('ngMuted', (value) => {
      if (value !== 'false') {
        element[0].muted = true;
      } else {
        element[0].muted = false;
      }
    });
  },
}));
